/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import LeMinerale from "../../../assets/images/sponsor/leminerale.png";
import LogoPemkot from "../../../assets/images/sponsor/pemkot-semarang.png";
import Kompas from "../../../assets/images/sponsor/kompas.png";
import Isoplus from "../../../assets/images/sponsor/isoplus.png";
import Asics from "../../../assets/images/sponsor/asics.png";
import Posh from "../../../assets/images/sponsor/posh.png";
import Generali from "../../../assets/images/sponsor/generali.jpg";
import EjSport from "../../../assets/images/sponsor/ejsport.png";
import Fitbar from "../../../assets/images/sponsor/fitbar.png";
import Santika from "../../../assets/images/sponsor/santika.jpg";
import BJB from "../../../assets/images/sponsor/bjb.png";
import Azzura from "../../../assets/images/sponsor/azzura.png";
import Garmin from "../../../assets/images/sponsor/garmin.png";
import Shokz from "../../../assets/images/sponsor/shokz.png";
import Cardea from "../../../assets/images/sponsor/cardea.png";
import Zinc from "../../../assets/images/sponsor/zinc.png";
import Pilkita from "../../../assets/images/sponsor/pilkita.png";
import Antangin from "../../../assets/images/sponsor/antangin.png";
import Duraking from "../../../assets/images/sponsor/duraking.png";
import TehPucuk from "../../../assets/images/sponsor/tehpucuk.jpg";
import Ciptadent from "../../../assets/images/sponsor/ciptadent.png";
import OliveMilk from "../../../assets/images/sponsor/olive-milk.png";

export default function Sponsor() {
  return (
    <div className="bg-white font-soulmaze text-xl">
      <div className="relative container w-full mx-auto py-24">
        <div className="grid md:grid-cols-3 uppercase gap-10 py-10">
          <div className="space-y-4 flex flex-col justify-start items-center text-center">
            <h2 className=" text-[#AE1F25]">POWERED BY</h2>
            <div className="flex h-full items-center justify-center">
              <a
                href="https://www.bankbjb.co.id/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={BJB}
                  alt="Logo Bank BJB"
                  className="lg:w-3/4 w-2/3 mx-auto"
                />
              </a>
            </div>
          </div>
          <div className="space-y-4 flex flex-col justify-start items-center text-center">
            <h2 className=" text-[#AE1F25]">MANAGED BY</h2>
            <div className="flex h-full items-center justify-center">
              <a href="https://www.kompas.id/" target="_blank" rel="noreferrer">
                <img
                  src={Kompas}
                  alt="Logo Kompas"
                  className="lg:w-3/4 w-full mx-auto"
                />
              </a>
            </div>
          </div>
          <div className="space-y-4 flex flex-col justify-start items-center text-center">
            <h2 className=" text-[#AE1F25]">GOVERNMENT PARTNER</h2>
            <div className="flex h-full items-center justify-center">
              <a
                href="https://www.semarangkota.go.id/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={LogoPemkot}
                  alt="Logo Pemkot Semarang"
                  className="lg:w-3/4 w-full mx-auto"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 uppercase gap-10 py-10 px-10 text-center">
          <div className="space-y-4 flex flex-col justify-start items-center text-center">
            <h2 className=" text-[#AE1F25]">OFFICIAL WATER</h2>
            <div className="flex h-full items-center">
              <a
                href="https://www.leminerale.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={LeMinerale}
                  alt="Logo Le Minerale"
                  className="md:w-3/6 mx-auto"
                />
              </a>
            </div>
          </div>
          <div className="space-y-0 flex flex-col justify-start items-center text-center">
            <h2 className=" text-[#AE1F25]">OFFICIAL ISOTONIC</h2>
            <div className="flex h-full items-center">
              <a
                href="https://wingscorp.com/brand-detail/isoplus/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Isoplus}
                  alt="Logo Isoplus"
                  className="md:w-3/6 mx-auto"
                />
              </a>
            </div>
          </div>
          <div className="space-y-4 flex flex-col justify-start items-center text-center col-span-2 md:col-span-1">
            <h2 className=" text-[#AE1F25]">OFFICIAL INSURANCE</h2>
            <div className="flex h-full items-center">
              <a
                href="https://www.generali.co.id/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Generali}
                  alt="Logo Generali"
                  className="md:w-3/6 w-3/5 mx-auto"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="py-12 lg:px-24">
          <div className="text-center mb-4">
            <h2 className=" text-[#AE1F25]">CO - SPONSOR</h2>
          </div>
          <div className="flex flex-wrap justify-center px-4">
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://entrasol.com/produk/entrasol-can-susu-steril"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={OliveMilk}
                  alt="Logo O'live Milk"
                  className="w-4/5 mx-auto"
                />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a href="https://asics.co.id/" target="_blank" rel="noreferrer">
                <img src={Asics} alt="Logo Asics" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://ejsportofficial.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={EjSport} alt="Logo EJ Sport" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://www.zinc.co.id/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Zinc} alt="Logo Zinc" className="mx-auto w-4/5" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://azzuracosmetics.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Azzura} alt="Logo Azzura" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://ciptadent.co.id/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Ciptadent} alt="Logo Ciptadent" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://www.poshindonesia.id/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Posh} alt="Logo Posh" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://kalbenutritionals.com/id/produk-kami/fitbar"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Fitbar} alt="Logo Fitbar" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://www.deltomed.id/our-brands/pilkita-1"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Pilkita} alt="Logo Pilkita" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://www.deltomed.id/our-brands/antangin"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Antangin} alt="Logo Antangin" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://www.mysantika.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Santika} alt="Logo Santika" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-1/12 p-4">
              <a
                href="https://duraking.co.id/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Duraking}
                  alt="Logo Duraking"
                  className="mx-auto w-2/6 md:w-3/6"
                />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a href="https://cardea.asia/" target="_blank" rel="noreferrer">
                <img src={Cardea} alt="Logo Cardea" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://asia.shokz.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Shokz} alt="Logo Shokz" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://www.garmin.co.id/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Garmin} alt="Logo Garmin" className="mx-auto" />
              </a>
            </div>
            <div className="flex items-center justify-center h-24 w-1/3 md:w-[12.5%] p-4">
              <a
                href="https://instagram.com/pucukharumid"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={TehPucuk}
                  alt="Logo Teh Pucuk"
                  className="mx-auto w-4/6"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
